import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { 
  FaFacebookF, 
  FaInstagram, 
  FaPhoneAlt,
  FaMapMarkerAlt 
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section" dir="rtl">
      <Container>
        <Row className="gy-3 align-items-center">
          <Col lg={5} md={12} className="footer-col">
            <div className="footer-brand-container">
              <h3 className="footer-brand-name">Bayti بيتي</h3>
            </div>
            <p className="footer-about-text">
              شريكك الموثوق للعثور على العقار المثالي بأفضل العروض.
            </p>
          </Col>

          <Col lg={7} md={12} className="footer-col">
            <div className="footer-flex-container">
              <div className="contact-mini-info">
                <span>
                  <FaMapMarkerAlt className="info-icon" /> كفر قاسم
                </span>
                <span dir="ltr">
                  <FaPhoneAlt className="info-icon" /> +972 53-623-3649
                </span>
              </div>
              
              <div className="social-icons-wrapper">
                <a href="https://www.facebook.com/share/189eD4vD9b/?mibextid=wwXIfr"  rel="noopener noreferrer" className="social-btn">
                  <FaFacebookF />
                </a>
                <a href="https://www.instagram.com/baytiltd?igsh=d25tYWs5OHd2N2Fr&utm_source=qr"  rel="noopener noreferrer" className="social-btn">
                  <FaInstagram />
                </a>
                {/*<a href="https://linkedin.com"  rel="noopener noreferrer" className="social-btn">
                  <FaLinkedinIn />
                </a>*/}
              </div>
            </div>
          </Col>
        </Row>

        <hr className="footer-hr" />

        <div className="footer-bottom-bar text-center">
          <p className="copyright-msg">

             جميع الحقوق محفوظة © {currentYear} لـ <strong>Bayti بيتي</strong>

          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;